import React, { ReactElement, forwardRef, MutableRefObject } from "react";
import { observer } from "mobx-react";
import buttonStyles from "ui/Button/Button.module.scss";
import SearchIcon from "assets/icons/search.svg";
import { useStore } from "store";
import { cn } from "helpers/style";
import { gtm } from "helpers/analytics";
import { useBreakpoint } from "helpers/hooks";
import SearchInput from "./components/SearchInput/SearchInput";
import styles from "./Search.module.scss";

type Props = {
  className?: string;
  buttonClassName?: string;
  stickyIsOpen?: boolean;
  classNameOverlay?: string;
  sticky?: boolean;
};

export type ControlledInputType = {
  clear: () => void;
  input: MutableRefObject<HTMLInputElement>["current"];
  goToSearchPage?: (key?: string) => void;
};

const Search = forwardRef<ControlledInputType, Props>(
  (
    {
      className,
      buttonClassName,
      stickyIsOpen,
      classNameOverlay,
      sticky,
    }: Props,
    ref: MutableRefObject<ControlledInputType>
  ): ReactElement => {
    const { search } = useStore();
    const breakpoint = useBreakpoint(true);

    const isMobile = breakpoint === "mobile";
    const opened = search.value?.length;

    const goToSearchPage = () => {
      if (!search.value.length) return;
      ref.current?.goToSearchPage();
      gtm.onChoiceFromSearch(search.value || "");
    };

    return (
      <div
        className={cn([
          styles.search,
          opened && styles.searchOpened,
          className,
        ])}
      >
        <SearchInput
          ref={ref}
          stickyIsOpen={stickyIsOpen}
          className={cn([opened && styles.searchSuggestionsOpened])}
          classNameOverlay={cn([
            classNameOverlay,
            opened && styles.searchOverlayOpened,
          ])}
          sticky={sticky}
        />

        <button
          className={cn([
            styles.searchButton,
            buttonStyles.button,
            buttonStyles.buttonOrange,
            buttonClassName,
          ])}
          onClick={goToSearchPage}
        >
          {isMobile ? <SearchIcon /> : "Найти"}
        </button>
      </div>
    );
  }
);

Search.displayName = "Search";
export default observer(Search);
